import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const BannerSingle = () => {
  const navigate = useNavigate();
  const [news, setNews] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/banners/list`
        );
        const bannerid = window.location.href.split('/').pop();
        if (bannerid) {
          setNews(
            response.data.data.filter((item) => String(item.id) === bannerid)[0]
          );
        } else {
          navigate('/banners/list');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const prettyDate = (zuluDate) => {
    const date = new Date(zuluDate);

    const formattedDate = `${date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })} ${date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })}`;

    return formattedDate;
  };

  return (
    <>
      <PageHeader
        title='Sliding Banner Details'
        description=''
        className='mb-3'
      ></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : news?.id ? (
        <Table hover responsive>
          <tbody>
            <tr>
              <td>Title: {news.title}</td>
            </tr>

            <tr>
              <td>
                <img
                  className='rounded'
                  width={500}
                  src={news.doc_url}
                  alt={news.title}
                />
              </td>
            </tr>
            <tr>
              <td>Audience: {news.audience}</td>
            </tr>
            <tr>
              <td>Enabled: {news.enabled}</td>
            </tr>
            <tr>
              <td>
                Image File:{' '}
                <Link href={news.doc_url} target='_blank'>
                  {news.doc_url}
                </Link>
              </td>
            </tr>
            <tr>
              <td>Date added: {prettyDate(news.date_added)}</td>
            </tr>
            <tr>
              <td>Expiry date: {prettyDate(news.date_expiry)}</td>
            </tr>
            <tr>
              <td>Date updated: {prettyDate(news.date_updated)}</td>
            </tr>
            <tr>
              <td>Post date: {prettyDate(news.post_date)}</td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <div>Banner not found</div>
      )}
    </>
  );
};

export default BannerSingle;
